<template>
    <div id="UserInfo" class="UserInfo">
        <div id="user_head" class="user_head_backgound clearfix" :style="'background-image:url('+imgPath+'user/mountBg.jpg)'">
            <div class="user_head_img"><img :src="headImg"/></div>
            <div class="user_head_name">
                <p>{{nickname}}</p>
                <p>余额：¥ {{balance}}</p>
            </div>
            <!-- <router-link to="/set" class="user_set">
                <img class="user_head_set_img" :src="imgPath+'user/user_set.png'"/>
            </router-link> -->
        </div>
        
        <div class="menuBox">
          <div class="userMenu">
              <a @click="withdrawals">
                  <div class="img"><img :src="imgPath+'user/recharge.png'"/></div>
                  <span>提现</span>
              </a>
              <router-link to="/income">
                  <div class="img"><img :src="imgPath+'user/income.png'"/></div>
                  <span>收入</span>
              </router-link>
              <a @click="toOrders">
                  <div class="img"><img :src="imgPath+'user/orders2.png'"/></div>
                  <span>订单</span>
              </a>
              <a @click="toDistribution">
                  <div class="img"><img :src="imgPath+'user/sales2.png'"/></div>
                  <span>分销</span>
              </a>
          </div>
        </div>

        <van-cell-group>
          <van-cell is-link to="/cards">
            <img class="user_image_type_img" :src="imgPath+'user/user_card.png'"/>
            <span class="van-cell-text">我的卡包</span>
          </van-cell>
          <van-cell is-link to="/historys">
            <img class="user_image_type_img" :src="imgPath+'user/user_eye.png'"/>
            <span class="van-cell-text">观看历史</span>
          </van-cell>
          <van-cell is-link @click="toLiveCenter">
            <img class="user_image_type_img" :src="imgPath+'user/user_live.png'"/>
            <span class="van-cell-text">直播中心</span>
          </van-cell>
          <!-- <van-cell is-link @click="toSalesCenter">
            <img class="user_image_type_img" :src="imgPath+'user/user_sales.png'"/>
            <span class="van-cell-text">分销中心</span>
          </van-cell> -->
          <van-cell is-link @click="toAddr">
            <img class="user_image_type_img" :src="imgPath+'user/addrs.png'"/>
            <span class="van-cell-text">地址管理</span>
          </van-cell>
          <van-cell is-link to="/expend">
            <img class="user_image_type_img" :src="imgPath+'user/consumption2.png'"/>
            <span class="van-cell-text">消费中心</span>
          </van-cell>
          <van-cell is-link to="/cash/1">
            <img class="user_image_type_img" :src="imgPath+'user/jiangpin2.png'"/>
            <span class="van-cell-text">奖品中心</span>
          </van-cell>
					 <van-cell @click="clearDataAction">
					  <img class="user_image_type_img" :src="imgPath+'user/huancunqingli.png'"/>
					  <span class="van-cell-text">清空缓存数据</span>
					</van-cell>
          <van-cell @click="goBack" v-if="ds_id">
            <img class="user_image_type_img" :src="imgPath+'user/live_back.png'"/>
            <span class="van-cell-text">返回直播</span>
          </van-cell>
        </van-cell-group>

        <van-popup position="right" v-model="show">
            <div class="box-center clearfix">
                <div class="fr">
                    <van-button type="default" size="small" @click="closePp()">取消</van-button>
                </div>
            </div>
            <div class="valuebox">
                <div>
                  <h5 class="fr">您的余额为<b class="red">{{balance}}</b> <van-button size="small" type="primary" @click="allPay()"> 全部提现 </van-button></h5>
                  <h4>提现金额</h4>
                </div>
                <div class="input clearfix">
                  <span class="fl">￥</span>
                  <input type="text"  v-model="value" class="fl red" disabled="">
                </div>
                <h6 class="red">特别说明：余额超过2元可提现，将收取20%的手续费，申请成功后在1-2小时内入账微信钱包</h6>
            </div>
            <div class="linebox">
                <van-button v-if="payBut" type="primary" size="large" @click="payment()">立即提现</van-button>
                <van-button v-else disabled size="large">立即提现</van-button>
              </div>
            <van-number-keyboard
              :show="show"
              extra-key="."
              @input="onInput"
              @delete="onDelete"
            />
        </van-popup>

        <van-popup v-model="tixianType">
          <div class="box-center">
            <img :src="imgPath+'user/ok.png'">
            <h4 class="bigsize">提现成功</h4>
            <p>已提现<span class="red">{{realMoney*100/100}}元</span>至微信钱包</p>
            <van-button type="primary" size="large" @click="ok()">确定</van-button>
          </div>
        </van-popup>
        
        <van-popup v-model="showPhone">
          <div class="band">
            <div class="title">提示</div>
            <div class="form">
              <p>为了保证您的账户安全，<span>首次提现</span>需要进行手机绑定。</p>
              <div class="phone">
                <label>手机号码：</label>
                <input type="tel" v-model="mobile" name="mobile" maxlength="11" minlength="11"></div>
              <div class="code">
                <label>验证码：</label>
                <input type="text" v-model="code" name="code" maxlength="6">
                <a v-if="showGet" class="getcode" @click="getCode">获取验证码</a>
                <a v-else class="getcode">{{seconds}}秒</a>
              </div>
            </div>
            <div class="btns clearfix">
              <a class="confirm" @click="onConfirm">确认</a>
              <a class="cancel" @click="onCancel">取消</a>
            </div>
          </div>
        </van-popup>

        <van-popup v-model="isShowQRimg">
          <div class="codebox">
            <p>{{qrCodeTitle}}</p>
            <img :src="qrCodeUrl" class="stop" />
            <p v-if="qrCodeStr">{{qrCodeStr}}</p>
            <p v-else>关注公众号后方可提现</p>
          </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import tool,{app_Id} from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
import { Toast } from 'vant';
import { Button } from 'vant';
Vue.use(Button);
import { Icon } from 'vant';

Vue.use(Icon);
import { Dialog } from 'vant';

export default {
    data() {
        return {
            initData:{},
            fans_id:'',
            nickname:'',
            show:false,
            value:'',
            balance:'0',
            headImg:'',
            payBut:false,
            tixianType:false,
            realMoney:0,
            showPhone:false,
            mobile:'',
            code:'',
            seconds:120,
            showGet:true,
            ds_id:'',
            isShowQRimg:false,
            qrCodeTitle:'',
            qrCodeStr:'',
            qrCodeUrl:'',
            withdraw:false,
            followed:false,
            limitText:'',
            isWeixin:true,
            imgPath:''
        }
    },
    mounted() {
	  var that = this;
      Toast.loading({mask: true});
			this.imgPath = tool.imgPath();
			this.ds_id = tool.getQueryDsId();
			this.isWeixin = tool.isWeixin();
      tool.login(app_Id,function(fans){
				  //重缓存中获取数据
				that.fans_id = fans.fans_id;
				that.headerUrl = fans.header;
				
				that.getData();
			});

      if(this.ds_id){
        this.follow();
      }
			
      this.limitText = tool.getQueryString('text');
      if(this.limitText){
        tool.setCookie(this.limitText,true,30);
        location.href = location.href.split('&text')[0]+'#/user';
      }
    },
    methods: {
      follow(){
        this.initData = vxxData.getInitData();

        if(!this.initData){
          return;
        }
        var Obj = {};
        for(let j of this.initData.ds_func){
          Obj[j.module] = j.params || true;
        }
        if(Obj.wx_follow) { //微信关注二维码
          this.qrCodeUrl = Obj.wx_follow.pic_url;
          this.qrCodeStr = Obj.wx_follow.wx_withdraw_des;
          this.qrCodeTitle = Obj.wx_follow.wx_name;
          if(Obj.wx_follow.wx_withdraw == 'yes'){
            this.withdraw = true;
          }else{
            this.withdraw = false;
          }
          if(tool.getCookie(Obj.wx_follow.wx_nameSec)){
            this.followed = true;
          }else{
            this.followed = false;
          }
        }
      },
      getData (){
        var that = this;
        this.axios.post(tool.baseUrl()+"/fans/finance/balance",'fans_id='+this.fans_id).then(function(data){
          Toast.clear();
          var userms = data.data.data;
            if(data.data.code == "200") {
              Toast.clear();
              that.balance = userms.balance;
              that.headImg = userms.header;
              that.nickname = userms.nick;
            } else {
              Toast("请求错误");
            }
        }).catch(function(res){
            Toast.clear();
            Toast("请求错误");
        })
      },
        withdrawals(){
          if(this.balance < 2){
            Toast("您的余额小于2元，暂不能提现");
            return false;
          }
          console.log(this.withdraw)
          if(!this.followed && this.withdraw){
            this.isShowQRimg = true;
            return false;
          }
          if(localStorage.getItem('real_auth') == 0){
            this.showPhone = true;
            return false;
          }
          this.show =true;
        },
        onConfirm(){
          var that = this;
          var url = tool.baseUrl()+'/fans/index/real_auth';
          var option = 'mobile='+this.mobile+'&fans_id='+this.fans_id+'&code='+this.code;
          if(!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)){
            Toast('请填写正确的手机号码')
            return false
          }
          if(!/^\d{6}$/.test(this.code)){
            Toast('请填写验证码');
            return false;
          }
          this.axios.post(url,option).then(function(res){
            var data = res.data;
            Toast(data.message);
            if(data.code == 200){
              that.showPhone = false;
              tool.setCookie('real_auth',1,5)
              that.show = true;
              that.mobile = '';
              that.code = '';
            }
          }).catch(function(res){
            Toast(res.data.message)
          })
        },
        onCancel(){
          this.showPhone = false;
          this.mobile = '';
          this.code = '';
        },
        onCloseQRCode() {
          this.isShowQRimg = !this.isShowQRimg;
        },
        payment(){
          var that = this;
          this.payBut = false;
          Toast.loading({duration:0,message: '正在申请提现'});
          this.axios.post(tool.baseUrl()+"/fans/Enchashment/index",'fans_id='+this.fans_id+'&money='+this.value).then(function(data){
            Toast.clear();
            var userms = data.data.data;
              if(data.data.code == "200") {
                that.realMoney = userms.realMoney;
                that.tixianType = true;
                that.getData();
                that.show = false;
                that.value='';
              } else {
                Toast(data.data.message);
                that.show = false;
                that.value = '';
              }
            }).catch(function(res){
                Toast("请求错误");
            })
        },
        getCode(){
          var that = this;
          var url = tool.baseUrl()+'/common/SendSms/send';
          var option = 'mobile='+this.mobile+'&type=certification';
          if(!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)){
            Toast('请填写正确的手机号码')
            return false
          }
          this.axios.post(url,option).then(function(res){
            var data = res.data;
            Toast(data.message);
            if(data.code == 200){
              that.showGet = false;
              that.countdown();
            }
          }).catch(function(res){
            Toast(res.data.message)
          })
        },
        countdown(){
          var that = this;
          var timer = setInterval(function(){
            that.seconds -- ;
            if(that.seconds == 0){
              that.showGet = true;
              clearInterval(timer);
              that.seconds = 120;
            }
          },1000)
        },
        closePp(){
            this.value = '';
            this.show = false;
        },
        onInput(key) {
          this.value = (this.value + key);
          if(/^[1-9]+[0-9]?(\.\d{1,2})?$/.test(Number(this.value))){
            if(Number(this.value) === 0){
              this.value = '';
              Toast("首位不能为0")
            }else if(Number(this.value) > 1){
              this.payBut = true;
              if(Number(this.value) > this.balance){
                Toast("最多可提现"+this.balance+'元');
                this.value=this.value.substring(0,this.value.length-1);
              }
            }
          }else{
            this.value=this.value.substring(0,this.value.length-1);
            Toast("最多可输入2位小数");
          }
        },
        onDelete() {
          this.value = this.value.slice(0, this.value.length - 1);
          if(parseInt(this.value) <= 1 || !this.value){
            this.payBut = false;
          }
        },
        allPay(){
          this.value = this.balance.toString();
          this.payBut = true;
        },
        ok(){
          this.tixianType = false;
        },
        goBack(){
          this.$router.push({'path':'/home'})
        },
        toLiveCenter(){
          location.href = 'http://ph.shikee.tv/phoneAdmin/#/manageBackstage';
        },
        toSalesCenter(){
          location.href = 'http://ph.shikee.tv/sales/#/index';
        },
        toOrders(){
          location.href = 'http://ph.shikee.tv/store/#/orders';
        },
        toDistribution(){
          location.href = 'http://ph.shikee.tv/store/#/Distribution';
        },
        toAddr(){
          location.href = 'http://ph.shikee.tv/store/#/addrs';
        },
				clearDataAction(){
					  Dialog.confirm({
							title: '提示',
							message: '是否清空缓存数据重新登录'
						}).then(() => {
							// on confirm
							localStorage.clear();
							// 从 sessionStorage 删除所有保存的数据
              sessionStorage.clear();
							location.reload();
						}).catch(() => {
							// on cancel
						});
				}
    }
}
</script>

<style scoped>
img {
  vertical-align: middle;
}

a {
  color: #333;
}

.UserInfo {
  background-color: #f5f5f5;
}

.user_head_backgound {
  height: 150px;
  background-color: #1b75f9;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100% auto;
  position: relative;
  overflow: hidden;
}

.user_head_img {
  width: 68px;
  height: 68px;
  margin: 19px auto 0;
  border-radius: 50%;
  overflow: hidden;
  background: blue;
  border: 1px solid #fff;
}

.user_head_img img {
  width: 100%;
}

.user_head_name {
  color: #fff;
  display: flex;
  line-height: 16px;
  overflow: hidden;
  margin-top: 10px;
  font-size: 15px;
}

.user_head_name p {
  flex: 1;
  padding: 0 18px;
}

.user_head_name p:first-child {
  text-align: right;
  border-right: 1px solid #fff;
}

.user_set {
  position: absolute;
  top: 10px;
  right: 10px;
}

.user_head_set_img {
  width: 30px;
  height: 30px;
}

.menuBox {
  height: 94px;
  background: #f1f1f1;
  position: relative;
  margin: 0 12px;
}

.userMenu {
  position: absolute;
  width: 100%;
  top: -24px;
  display: flex;
  padding: 10px 0;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(91,91,91,0.3);
}

.userMenu a {
  flex: 1;
  padding: 4px 0;
  text-align: center;
  font-size: 12px;
  color: #333;
  line-height: 24px;
}

.userMenu .img {
  height: 44px;
  width: 44px;
  line-height: 43px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  background: #3976ff;
  margin: 0 auto;
  margin-bottom: 4px;
}

.userMenu a:nth-child(1) .img {
  background: linear-gradient(#76d139,#66b82f);
}

.userMenu a:nth-child(2) .img {
  background: linear-gradient(#ffb546,#ff9000);
}

.userMenu a:nth-child(3) .img {
  background: linear-gradient(#719eff,#477ef5);
}

.userMenu a:nth-child(4) .img {
  background: linear-gradient(#ff5a5a,#f25252);
}

.userMenu img {
  width: 27px;
}

.user_image_type_img {
  width: 21px;
  float: left;
  margin-right: 10px;
  margin-top: 2px;
  font-size: 20px;
  font-weight: bold;
}
.van-cell:nth-child(4n) .user_image_type_img{
  color: #66b82f;
}
.van-cell:nth-child(4n+1) .user_image_type_img{
  color: #ff9000;
}
.van-cell:nth-child(4n+2) .user_image_type_img{
  color: #477ef5;
}
.van-cell:nth-child(4n+3) .user_image_type_img{
  color: #f25252;
}

.van-cell {
  padding: 15px 15px 15px 15px;
}

.user_type_backgound {
  width: 100%;
  padding-left: 10px;
  padding-top: 8px;
  padding-bottom: 4px;
  background-color: white;
  box-sizing: border-box
}

.user_type_text {
  position: absolute;
  width: 200px;
  left: 30px;
  font-size: 12px;
  padding-top: 2px;
  margin-top: auto;
  padding-left: 6px;
}

.user_type_goto {
  position: absolute;
  margin: 0 auto;
  padding-top: 6px;
  height: 10px;
  right: 16px;
}

.valuebox {
  width: 90%;
  margin: 10px auto;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
  padding: 10px;
  color: #999;
}

.valuebox .input {
  position: relative;
  padding: 5px 0;
}

.valuebox input {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: none;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
  padding-left: 30px;
  font-size: 18px;
}

.valuebox .input span {
  font-size: 24px;
  position: absolute;
  top: 8px;
  left: 0;
  color: #666;
}

.valuebox h6 {
  line-height: 32px;
}

.van-popup--right {
  width: 100%;
  height: 100%;
  right: -10px;
  border-radius: 0;
}

.band {
  margin: -10px;
  background: #fff;
  border-radius: 10px;
}

.band .title {
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #099aff;
  color: #fff;
}

.form {
  padding: 20px;
  line-height: 28px;
}

.form p span {
  color: #099aff;
}

.phone {
  color: #383838;
  margin: 10px 0;
  padding-left: 5em;
  position: relative;
}

.form label {
  width: 5em;
  text-align: right;
  position: absolute;
  top: 0;
  left: 0;
}

.form input {
  border: 1px solid #989898;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

.form .code {
  position: relative;
  padding: 0 7em 0 5em;
}

.getcode {
  width: 6em;
  display: inline-block;
  position: absolute;
  text-align: center;
  right: 0.5em;
  top: 0;
  background: #099aff;
  color: #fff;
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
}

.btns {
  height: 40px;
  text-align: center;
}

.btns a {
  float: left;
  width: 50%;
  height: 40px;
  line-height: 40px;
}

.confirm {
  background: #099aff;
  color: #fff;
}

.cancel {
  background: #eeeded;
  color: #333333;
}

.codebox img {
  width: 80%;
}
.UserInfo ..van-button--large{
  background-color: #4a7ae6;
}
.red{
	color: red;
}
</style>


// WEBPACK FOOTER //
// UserInfo.vue?2f41fde5